// Thin, safe wrapper around the global gtag() installed in public/index.html.
// Guards against gtag being absent (blocked by an ad blocker, or not yet
// loaded) so analytics calls never throw. Replaces react-ga4, which injected
// its own gtag ~4s after load — too late for Google Ads tag detection.
export const gtag = (...args) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag(...args);
  }
};
